import React from "react"
import { FormGroup, FormControl, FormLabel, Button, Row, Col } from "react-bootstrap"
import { connect } from "react-redux"
import { IssueManagementSelect } from "selects/containers/PieSelect"
import PropTypes from "prop-types"
import swal from "sweetalert"

import { createNewList } from "projects-new/issue-management/action-creators/lists-page-action-creators"

import { selectAllActiveDeserializedFilters } from "shared/search/selectors"

const defaultProps = {
    id: "create-list-inline",
    topIcon: "search-plus",
    text: "Create List",
}

/* eslint-disable react/no-unused-prop-types */
const propTypes = {
    quorumDataType: PropTypes.number.isRequired,
    onSuccessHide: PropTypes.func,
    text: PropTypes.string,
    dispatch: PropTypes.func,
    parentSearchFilter: PropTypes.object,
    onCreateListClick: PropTypes.func,
    closeModalFunc: PropTypes.func,
    allActiveDeserializedFilters: PropTypes.object,
}
/* eslint-enable react/no-unused-prop-types */

const mapStateToProps = (state, props) => ({
    allActiveDeserializedFilters: selectAllActiveDeserializedFilters(state, props),
})

const actions = { createNewList }

export class CreateListForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            createListName: undefined,
            selectedBoardId: null,
            quorumDataType: undefined,
        }
        this.handleCreateListInputChange = this.handleCreateListInputChange.bind(this)
        this.handleCreateListClick = this.handleCreateListClick.bind(this)
        this.changeBoard = this.changeBoard.bind(this)
    }

    changeBoard(board) {
        board ? this.setState({ selectedBoardId: board.id }) : this.setState({ selectedBoardId: null })
    }
    getCloseButton() {
        if (!this.props.closeModalFunc) {
            return null
        }
        return (
            <Col md={6}>
                <Button onClick={this.props.closeModalFunc} variant="default-white" className="btn-block">
                    Cancel
                </Button>
            </Col>
        )
    }

    runValidation() {
        // check that user has provided a list name
        if (this.state.createListName === "" || !this.state.createListName) {
            this._nameInput.focus()
            return false
        }
        // check that boardId was provided
        if (!this.state.selectedBoardId) {
            swal("Error", "You must select an issue", "error")
            return false
        }
        return true
    }

    async handleCreateListClick(...args) {
        // validate inputs
        if (!this.runValidation()) {
            return null
        }

        if (this.props.onCreateListClick) {
            // this is called from the BulkEmail profile.
            return this.props.onCreateListClick(this, args)
        }

        const { added_ids, deleted_ids, ...newListFilters } = this.props.allActiveDeserializedFilters.size
            ? this.props.allActiveDeserializedFilters.toJS()
            : {}

        const response = await this.props.createNewList({
            name: this.state.createListName,
            issueId: this.state.selectedBoardId,
            dataType: this.props.quorumDataType,
            searchifyFilters: {
                querysetList: this.props.allActiveDeserializedFilters.size ? [newListFilters] : [],
                addedIds: added_ids || [],
                deletedIds: deleted_ids || [],
            },
        })
        if (response) {
            this.props.onSuccessHide()
            swal("Success!", "Your list has been created.", "success")
            return true
        }
        return false
    }

    handleCreateListInputChange(e) {
        this.setState({ createListName: e.target.value })
    }

    render() {
        const btnSize = this.props.closeModalFunc ? 6 : 12
        return (
            <div className="wizard-container-advanced-search" data-cy="wizard-container-advanced-search">
                <div className="wizard-title-container-div">
                    <h1>{this.props.text}</h1>
                </div>
                <FormGroup className="form-group">
                    <FormLabel>Name</FormLabel>
                    <FormControl
                        data-cy="search-name-input"
                        inputRef={(ref) => (this._nameInput = ref)}
                        className="search-name-input"
                        type="text"
                        placeholder="Name your list..."
                        onChange={this.handleCreateListInputChange}
                    />
                </FormGroup>
                <FormGroup className="form-group">
                    <span>
                        <FormLabel>Select Issue</FormLabel>
                        <IssueManagementSelect value={this.state.selectedBoardId} onChange={this.changeBoard} />
                    </span>
                </FormGroup>
                <Row>
                    {this.getCloseButton()}
                    <Col md={btnSize}>
                        <Button onClick={this.handleCreateListClick} variant="primary" block>
                            Create List in Issue
                        </Button>
                    </Col>
                </Row>
            </div>
        )
    }
}

CreateListForm.defaultProps = defaultProps
CreateListForm.propTypes = propTypes

export default connect(mapStateToProps, actions)(CreateListForm)
